export default __webpack_public_path__ + "static/media/ic-transfer-success.32cc5d73.svg";